export default __webpack_public_path__ + "static/media/Blanket1.227053c7.png";